import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {ResponseContentType} from '@angular/http';
import {ImageHolder} from './image-holder.interface';

@Injectable()
export class ExceptionPhotosService {

  constructor(private http: AuthHttp) {
  }

  public getImagesList(id: number): Promise<Array<ImageHolder>> {
    return this.http
      .get(`${environment.baseUrl}listimages/${id}`)
      .map((res) => res.json()).toPromise();
  }

  public getImage(uuid: string): Promise<Blob> {
    return this.http
      .get(`${environment.baseUrl}image/${uuid}`, { responseType: ResponseContentType.Blob })
      .map((res) => res.blob()).toPromise();
  }
}





// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/exception-photos/exception-photos.service.ts